export const SET_CURRENT_PROFILE = "SET_CURRENT_PROFILE";

export const REDUCE_DATING_COUNT = "REDUCE_DATING_COUNT";
